export const POLICY_PRICE_MULTIPLIER = 2.5;
